var _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEuroGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38631 14.5899C6.47722 18.0461 9.5454 20.1429 13.5227 20.1429C15.9999 20.1429 17.9318 19.3134 19.4999 17.8387L17.5909 15.3963C16.5681 16.318 15.2045 16.894 13.7727 16.894C11.8409 16.9171 10.2727 16.0645 9.38631 14.5899L8.68176 12.4931C8.65904 12.2166 8.63631 11.9171 8.63631 11.6175C8.63631 11.341 8.65904 11.0645 8.68176 10.8111L9.2954 8.71429C10.1136 7.17051 11.659 6.27189 13.5227 6.27189C15.1818 6.27189 16.4545 6.94009 17.409 7.90784L19.4772 5.30415C18.1363 3.9447 16.1136 3 13.4772 3C9.5454 3 6.43176 5.21198 5.34085 8.71429L4.95449 10.8111C4.93176 11.0645 4.93176 11.318 4.93176 11.5945C4.93176 11.894 4.95449 12.1936 4.97722 12.4931L5.38631 14.5899Z",
    fill: "#CBCBDD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 8.71429,
    width: 10.2857,
    height: 2.28571,
    fill: "#CBCBDD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 12.1429,
    width: 10.2857,
    height: 2.28571,
    fill: "#CBCBDD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroGrey);
export default __webpack_public_path__ + "static/media/euro-grey.e870d26ba8cbe58553925b61a72af15c.svg";
export { ForwardRef as ReactComponent };